module.exports = __webpack_public_path__ + "img/DE02643.a8a5356f.png";